import React from "react";
import { strings, withLocalizeStrings } from "../../../languages/Localize";
import styled from "styled-components";
import { Flex } from "reflexbox/src";
import TitleSeparator from "../../../components/title-separator/TitleSeparator";
import { Box } from "reflexbox";
import { useRegisterStateValue } from "../../RegisterContext";
import { Button } from "antd";
import { useHistory } from "react-router";
import { registerScreens } from "../../../util/util";

const StyledQRCode = styled(Flex)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
`;

const ContentBox = styled(Flex)`
    width: 92%;
    flex: 1;
    text-align: center;
    flex-direction: column;
    && {
        margin: 12px 4% 0% 4%;
    }
`;

const StyledQrCode = styled(Flex)`
    justify-content: center;
`;

const StyledTitle = styled.span`
    color: #fff;
    padding-bottom: 10px;
`;

const StyledDescription = styled.span`
    color: #fff;
    padding: 10px 0px;
`;

const StyledButtonContainer = styled(Flex)`
    text-align: center;
    padding-bottom: 10px;
    flex-direction: column;
    align-items: center;
    text-decoration: underline;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.primary};
    width: 60%;
    min-width: 180px;
    height: 50px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 24px;
    &:focus,
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
    &:active {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const StyledSignOutButton = styled(Button)`
    background-color: ${({ theme }) => theme.colors.primary};
    width: 90%;
    min-width: 180px;
    height: 50px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 12px;
    color: #fff;
    && {
        margin-top: 8px;
    }
`;

const StyledLink = styled.a`
    color: ${({ theme }) => theme.colors.primary};
    && {
        margin-top: 4px;
        font-size: 20px;
    }
`;

const QrCode = props => {
    const { loginForm, changeScreen, setLoginForm } = useRegisterStateValue();

    const history = useHistory();

    const handleBackClick = () => {
        history.push("/");
    };

    return (
        <StyledQRCode>
            <TitleSeparator>{strings.register.qrCode.HEADER}</TitleSeparator>
            <ContentBox>
                <StyledTitle>{strings.register.qrCode.title}</StyledTitle>
                <StyledQrCode>
                    <img src={`${process.env.REACT_APP_API_ENDPOINT}api/accreditation/qrCode/${loginForm.code}`} />
                </StyledQrCode>
                <StyledDescription>{strings.register.qrCode.description}</StyledDescription>
            </ContentBox>
            <StyledButtonContainer sx={{ m: [3, 4], px: [1, 2], fontSize: [2, 3] }}>
                <StyledButton onClick={handleBackClick}>{strings.register.common.OK}</StyledButton>
                <StyledLink
                    onClick={() => {
                        localStorage.removeItem("qrCode");
                        setLoginForm({ code: null });
                        changeScreen(registerScreens.ACCREDITATION_START);
                    }}>
                    {strings.register.qrCode.signInWithDifferentAccreditation}
                </StyledLink>
            </StyledButtonContainer>
        </StyledQRCode>
    );
};

export default withLocalizeStrings(QrCode);
